<template>
  <!-- add session name form  -->
  <v-dialog v-model="dialog" persistent width="450" attach>
    <v-form ref="sesssionForm">
      <v-card>
        <v-card-title>
          <span class="text-h5">Session Details</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="sessionName"
                :rules="rules"
                label="Session name"
                clearable
                variant="outlined"
                density="comfortable"
                required
                class="mt-2"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" variant="outlined" @click="cancel()">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            type="button"
            @click="addToSaveForLater"
            variant="outlined"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>

  <!-- sign in popup -->
  <v-dialog v-model="signInForm" persistent flat max-width="500">
    <v-card flat>
      <v-card-title class="d-flex justify-space-between">
        <p class="h3 mb-0 whyte-regular-font">Sign In</p>
        <v-btn
          @click="closeSignInForm()"
          density="comfortable"
          variant="text"
          :ripple="false"
          icon
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-3 pb-0">
        <v-alert class="word-break" type="error" v-if="!!errorMessage">{{
          errorMessage
        }}</v-alert>
        <v-alert class="word-break" type="success" v-if="!!signInMessage">{{
          signInMessage
        }}</v-alert>
        <v-form ref="loginForm" v-model="validLogin">
          <v-col class="pt-3 pb-1">
            <v-text-field
              v-model="emailLogin"
              type="email"
              label="Email Address"
              ref="email"
              name="email"
              variant="outlined"
              density="comfortable"
              :rules="commonValidationRules.requiredRules"
            ></v-text-field>
          </v-col>
          <v-col class="pt-1 pb-0">
            <v-text-field
              v-model="passwordLogin"
              label="Password"
              ref="password"
              type="password"
              name="password"
              variant="outlined"
              density="comfortable"
              :rules="commonValidationRules.requiredRules"
            ></v-text-field>
          </v-col>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters>
          <v-col cols="12" class="px-7">
            <v-btn
              variant="flat"
              block
              color="primary"
              class="text-white"
              @click="signIn()"
              :disabled="inProgress"
            >
              <v-progress-circular
                :size="20"
                color="white"
                indeterminate
                v-if="inProgress"
              ></v-progress-circular>
              &nbsp;SIGN IN
            </v-btn>
          </v-col>
          <v-col cols="6" class="py-5 pl-7" align="left">
            <span
              class="text-decoration-none cursor-pointer text-primary"
              @click="openSignUpDialog()"
              >Sign Up</span
            >
          </v-col>
          <v-col cols="6" class="py-5 pr-7" align="right"> </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Sign Up -->
  <v-dialog v-model="signUpForm" persistent flat max-width="500">
    <v-card flat>
      <v-card-title class="d-flex justify-space-between">
        <p class="h3 mb-0 whyte-regular-font">Sign Up</p>
        <v-btn
          @click="closeSignUpForm()"
          density="comfortable"
          variant="text"
          :ripple="false"
          icon
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-3 pb-0">
        <v-alert class="word-break" type="error" v-if="!!errorMessage">{{
          errorMessage
        }}</v-alert>
        <v-alert class="word-break" type="success" v-if="!!signUpMessage">{{
          signUpMessage
        }}</v-alert>
        <v-form ref="signUpForm" id="signup-form" @submit.prevent="signUp">
          <v-text-field
            class="pt-2"
            label="First Name"
            type="text"
            ref="firstName"
            name="firstName"
            variant="outlined"
            density="comfortable"
            v-model="firstname"
            :rules="firstNameRules"
          ></v-text-field>
          <v-text-field
            class="pt-2"
            label="Last Name"
            type="text"
            ref="lastName"
            name="lastName"
            variant="outlined"
            density="comfortable"
            v-model="lastname"
            :rules="lastNameRules"
          ></v-text-field>

          <v-text-field
            class="pt-2"
            label="Email Id"
            type="email"
            ref="email"
            name="email"
            id="userEmail"
            variant="outlined"
            density="comfortable"
            v-model="email"
            :rules="signUpEmailRules"
          ></v-text-field>

          <v-text-field
            class="pt-2 mt-0"
            type="password"
            label="Password"
            ref="password"
            name="password"
            variant="outlined"
            density="comfortable"
            v-model="password"
            :rules="commonValidationRules.passwordRule"
          ></v-text-field>
          <v-checkbox
            v-model="newsletter"
            label="Subscribe to our newsletter"
            hide-details="true"
            color="indigo"
          ></v-checkbox>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters>
          <v-col cols="12" class="px-7">
            <v-btn
              variant="flat"
              block
              color="primary"
              class="text-white"
              @click="signUp(product)"
              :disabled="inProgress"
            >
              <v-progress-circular
                :size="20"
                color="white"
                indeterminate
                v-if="inProgress"
              ></v-progress-circular>
              &nbsp;SIGN UP
            </v-btn>
          </v-col>
          <v-col cols="6" class="py-5 pl-7" align="left">
            <span
              class="text-decoration-none cursor-pointer text-primary"
              @click="openSignInDialog()"
              >Sign In</span
            >
          </v-col>
          <v-col cols="6" class="py-5 pr-7" align="right"> </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
const craneShopUrl = import.meta.env.VITE_APP_CRANE_DAILY_URL;
const craneSessionTimer = import.meta.env.VITE_APP_CRANE_SESSION_TIMER;
import { createHelpers } from "vuex-map-fields";
const { mapFields: mapFieldsAuth } = createHelpers({
  getterType: "auth/getField",
  mutationType: "auth/updateField",
});
const { mapFields: registerInfo } = createHelpers({
  getterType: "registration/getField",
  mutationType: "registration/updateField",
});
import {
  googleAanalyticsEventSaveForLatter,
  commonValidationRules,
} from "@/services/util.service";
export default {
  name: "SaveForLaterComponent",
  props: ["saveForLaterModel","subTotal"],
  components: {},
  data: () => ({
    commonValidationRules,
    inProgress: false,
    dialog: false,
    sessionName: null,
    signUpForm: false,
    signInForm: false,
    valid: true,
    validLogin: false,
    lazy: false,
    firstNameRules: [
      (v) => !!v || "First Name is required",
      (v) => (v && v.length >= 3) || "First Name must be at least 3 characters",
    ],
    lastNameRules: [
      (v) => !!v || "Last Name is required",
      (v) => (v && v.length >= 3) || "Last Name must be at least 3 characters",
    ],
    signUpEmailRules: [
      (v) => !!v || "Email Id is required",
      (v) => /.+@.+\..+/.test(v) || "Email Id must be valid",
    ],
  }),
  // watch:{
  //   saveForLaterModel:{
  //     immediate: true,
  //     handler(){
  //       if(this.saveForLaterModel)
  //         this.addSaveForLater()
  //     }
  //   }
  // },
  computed: {
    ...mapFieldsAuth({
      oneLogin: "one",
      emailLogin: "one.email",
      passwordLogin: "one.password",
      errorMessage: "errorMessage",
      // inProgress: "inProgress",
      signInMessage: "signInMessage",
    }),
    ...registerInfo([
      "one",
      "one.firstname",
      "one.lastname",
      "one.newsletter",
      "one.email",
      "one.password",
      "signUpMessage",
    ]),
    basicInfo() {
      return this.$store.state.accountOne.one;
    },
    productDetails: function () {
      return this.$store.state.productOne.productDetails;
    },
    userAuth: function () {
      return this.$store.state.auth.userAuth;
    },
    builderSessionId: function () {
      return this.$route.params.sessionId;
    },
    userId: function () {
      if (this.userAuth && this.$store.state.accountOne.one)
        return this.$store.state.accountOne.one.id;
      return "";
    },
   
    // builder session details
    sessionOneDetails: function () {
      return this.$store.state.sessionOne.one;
    },
  },
  methods: {
    async addSaveForLater() {
      if (this.sessionOneDetails.isNameDefault) {
        this.sessionName = this.sessionOneDetails.name;
        this.dialog = true;
      } else {
        this.sessionName = this.sessionOneDetails.name;
        this.addToSaveForLater("no_default_name");
      }
    },
    async signUp() {
      try {
        // if (this.$refs.signUpForm.validate()) {
        const { valid } = await this.$refs.signUpForm.validate();
        if (valid) {
          this.inProgress = true;
          let vm = this
          try {
            this.$store.dispatch("auth/changeRedirectFlag", false);
            let status = await this.$store.dispatch("registration/signUp");
            if (status) {
              this.$store.dispatch("auth/changeRedirectFlag", false);
              await this.$store.dispatch("accountOne/basicInfo");
              if (this.builderSessionId) {
                await this.$store.dispatch(
                  "userCartProduct/cartProductList",
                  this.builderSessionId
                );
                if (this.basicInfo) {
                  await this.$store.dispatch("sessionOne/updateOne", {
                    sessionId: this.builderSessionId,
                    property: {
                      state: "saved",
                      orderState: null,
                      quoteData: null,
                      userData: {
                        customer_id: this.basicInfo.id,
                        customer_name: this.basicInfo.firstname,
                      },
                      isNameDefault: false,
                      name: this.sessionName,
                    },
                  });

                  if (window) {
                    window.DD_RUM.onReady(function() {
                      window.DD_RUM.addAction('studio_session', {
                        'session_id': vm.builderSessionId,
                        'session_state': 'save',
                       // 'price': vm.subTotal,
                        'sku': vm.sessionOneDetails.productData.sku,
                      })
                    })
                  }
                }

                // if (this.customAttributesOfCurrentProduct) {
                // let urlKey = customAttributeValue(
                //   this.customAttributesOfCurrentProduct,
                //   "url_key"
                // );
                localStorage.removeItem(`${craneSessionTimer}`);
                window.open(`${craneShopUrl}/me/saved-for-later`, "_self");
                // }

                this.signUpForm = false;
                this.signInForm = false;
                this.dialog = false;
                this.inProgress = false;

                this.$emit("closeSaveForLaterModal", this.dialog);
              }
            }
            this.inProgress = false;
          } catch (err) {
            console.log(err);
            this.inProgress = false;
          }
        }
      } catch (error) {
        this.inProgress = false;
        console.error("Error occured while sign up " + error);
      }
    },
    closeSignInForm() {
      this.signInForm = false;
      this.dialog = false;
      this.$store.dispatch("auth/changeRedirectFlag", true);
      this.$emit("closeSaveForLaterModal", this.dialog);
    },
    closeSignUpForm() {
      this.signUpForm = false;
      this.dialog = false;
      this.$store.dispatch("auth/changeRedirectFlag", true);
      this.$emit("closeSaveForLaterModal", this.dialog);
    },
    openSignInDialog() {
      this.signInForm = true;
      this.signUpForm = false;
      this.dialog = false;
    },
    openSignUpDialog() {
      this.signInForm = false;
      this.dialog = false;
      this.signUpForm = true;
    },
    // end of sign and signup

    cancel() {
      this.dialog = false;
      if (this.$refs && this.$refs.sesssionForm)
        this.$refs.sesssionForm.reset();
      this.$emit("closeSaveForLaterModal", this.dialog);
    },
    // sign in and sign up
    async signIn() {
      try {
        // this.cartProductsProgress = true;
        const { valid } = await this.$refs.loginForm.validate();
        if (valid) {
          let vm = this
          this.inProgress = true;
          this.$store.dispatch("auth/changeRedirectFlag", false);
          let status = await this.$store.dispatch("auth/login");
          if (status) {
            this.$store.dispatch("auth/changeRedirectFlag", true);
            await this.$store.dispatch("accountOne/basicInfo");
            if (this.builderSessionId) {
              await this.$store.dispatch(
                "userCartProduct/cartProductList",
                this.builderSessionId
              );
              if (this.basicInfo) {
                await this.$store.dispatch("sessionOne/updateOne", {
                  sessionId: this.builderSessionId,
                  property: {
                    state: "saved",
                    orderState: null,
                    quoteData: null,
                    userData: {
                      customer_id: this.basicInfo.id,
                      customer_name: this.basicInfo.firstname,
                    },
                    isNameDefault: false,
                    name: this.sessionName,
                  },
                });
                if (window) {
                  window.DD_RUM.onReady(function() {
                    window.DD_RUM.addAction('studio_session', {
                      'session_id': vm.builderSessionId,
                      'session_state': 'save',
                      // 'price': vm.subTotal,
                      'sku': vm.sessionOneDetails.productData.sku,
                    })
                  })
                }
                googleAanalyticsEventSaveForLatter(
                  this.productDetails,
                  "saved_for_later"
                );
              }

              // if (this.customAttributesOfCurrentProduct) {
              //   let urlKey = customAttributeValue(
              //     this.customAttributesOfCurrentProduct,
              //     "url_key"
              //   );
              localStorage.removeItem(`${craneSessionTimer}`);
              window.open(`${craneShopUrl}/me/saved-for-later`, "_self");
              // }

              this.signInForm = false;
              this.dialog = false;
            }
          }
          this.inProgress = false;
        }
        // this.cartProductsProgress = false;
        this.inProgress = false;
      } catch (err) {
        // this.cartProductsProgress = false;
        this.inProgress = false;
        console.error(err);
      }
    },
    async addToSaveForLater(option) {
      try {
        this.inProgress = true;
        let vm = this
        if (this.userAuth) {
          let isFormValid = false;
          if (option == "no_default_name") {
            isFormValid = true;
          } else {
            const { valid } = await this.$refs.sesssionForm.validate();
            isFormValid = valid;
          }
          if (isFormValid) {
            // if (this.userAuth) {
            let resp = await this.$store.dispatch("sessionOne/updateOne", {
              sessionId: this.builderSessionId,
              property: {
                state: "saved",
                quoteData: null,
                userData: {
                  customer_id: this.basicInfo.id,
                  customer_name: this.basicInfo.firstname,
                },
                isNameDefault: false,
                name: this.sessionName,
              },
            });

            if (resp && resp.response && window) {
              let currentSessionDetails = resp.response
              window.DD_RUM.onReady(function() {
                window.DD_RUM.addAction('studio_session', {
                  'session_id': vm.builderSessionId,
                  'session_state': 'save',
                  'sku': currentSessionDetails.productData.sku,
                 // 'price': vm.subTotal,
                })
              })
            } 

            if (this.$refs && this.$refs.sesssionForm)
              this.$refs.sesssionForm.reset();

            this.dialog = false;
            googleAanalyticsEventSaveForLatter(
              this.productDetails,
              "saved_for_later"
            );
            // if (this.customAttributesOfCurrentProduct) {
            // let urlKey = customAttributeValue(
            //   this.customAttributesOfCurrentProduct,
            //   "url_key"
            // );
            localStorage.removeItem(`${craneSessionTimer}`);
            window.open(`${craneShopUrl}/me/saved-for-later`, "_self");
            // }
            // }
          }
          this.inProgress = false;
        } else {
          this.signInForm = true;
          this.inProgress = false;
        }
      } catch (err) {
        this.$snotify.error(`Error in save for later ` + err.message, {
          position: "rightTop",
          showProgressBar: false,
        });
        this.saveIncident({
          errorObject: err,
          title: "Personalize error for save for later",
          description: "Error while user registration",
        });
        throw err;
      }
    },
  },
  created() {
    this.addSaveForLater();
  },
};
</script>
